import { createSelector } from '@reduxjs/toolkit';
import { getProfileState } from './getProfileState';

export const getPermissions = createSelector(getProfileState, (state) => state?.permissions);
